import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import './dashboard.scss'
import { DialogActions, DialogContent, DialogTitle, useStyles, StyledTableRow } from './dashboard-style'
import { useHover } from '../Support/CustomElements'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import SvgIcon from '@mui/material/SvgIcon'
import { styled } from '@mui/material/styles'
import { ReactComponent as AddCircle } from '../../assets/images/add-circle.svg'
import { ReactComponent as PencilIcon } from '../../assets/images/pencil.svg'
import { ReactComponent as DeleteBin } from '../../assets/images/bin.svg'
import CloseIcon from '@mui/icons-material/CloseOutlined'
import { IconButton } from '@mui/material/'
import Chip from '@mui/material/Chip'
import Paper from '@mui/material/Paper'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import { Link as RouterLink, useHistory, useLocation } from 'react-router-dom'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogContentText from '@mui/material/DialogContentText'
import TextField from '@mui/material/TextField'
import Fade from '@mui/material/Fade'
import Typography from '@mui/material/Typography'
import { setStrategy, setUserRecord } from '../../redux/actions'
import { connect, useSelector } from 'react-redux'
import * as _ from 'underscore'
import { countries } from '../../utilities/countries'
import Autocomplete from '@mui/material/Autocomplete'
import EditableMarketList from './EditableMarketList'
import store from '../../redux/store'
import { useAuth0 } from '../../contexts/auth0-context'
import callAPI from '../../API/callSecureAPI'
import endpoints from '../../API/endpoints'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import Tabs from '../../shared/components/Tabs/Tabs'
import ClearIcon from '@mui/icons-material/Clear'
import InputAdornment from '@mui/material/InputAdornment'
import callSecureAPI from '../../API/callSecureAPI'
import { uploadFile } from '../../API/PostRequests'
import ReactCountryFlag from 'react-country-flag'
import { Check, CancelOutlined } from '@mui/icons-material'
import { ReactComponent as MapIcon } from '../../assets/images/maps-mark.svg'
import { Logo } from '../Buttons/CreateButton'
import { LinearProgress, Alert } from '@mui/material'
import useEventLogger from '../../shared/hooks/useEventLogger'
import { useIsAdmin } from '../../shared/hooks/useIsAdmin'
import { useIsRoadmapReadonly } from '../../shared/hooks/useIsRoadmapReadonly'
import GetAppIcon from '@mui/icons-material/GetApp'
import download from 'downloadjs'
import { useGetStrategicAnchorFile } from '../../shared/queries/useGetStrategicAnchorFile'
import useValuePropositionDisplayName from '../../shared/hooks/useDisplayNames/variants/useValuePropositionDisplayName'
import { useQueryClient } from 'react-query'
import MetricsView from '../MetricsView'
import CommentsView from '../CommentsView'

const COMMENTS_DASHBOARD_PATH_SEGMENT_BY_TAB_ID = {
    all: 'all',
    strategicImperative: 'strategic-imperatives',
    valueMessage: 'value-messages',
    activity: 'activities',
    evidence: 'evidence',
    tpp: 'tpp',
}
const COMMENTS_DASHBOARD_TAB_ID_BY_PATH_SEGMENT = Object.entries(COMMENTS_DASHBOARD_PATH_SEGMENT_BY_TAB_ID).reduce(
    (acc, [tabId, pathSegment]) => {
        acc[pathSegment] = tabId
        return acc
    },
    {}
)
const METRICS_DASHBOARD_PATH_SEGMENT_BY_TAB_ID = {
    tpp: 'tpp',
    'value-message': 'value-message',
    activity: 'activity',
}

const METRICS_DASHBOARD_TAB_ID_BY_PATH_SEGMENT = Object.entries(METRICS_DASHBOARD_PATH_SEGMENT_BY_TAB_ID).reduce(
    (acc, [tabId, pathSegment]) => {
        acc[pathSegment] = tabId
        return acc
    },
    {}
)

function getDashboardTabIdFromPathname(pathname) {
    if (!pathname.startsWith('/dashboard')) {
        return 'overview'
    }

    const [, , dashboardTabId] = pathname.split('/')

    if (dashboardTabId === 'metrics' || dashboardTabId === 'comments') {
        return dashboardTabId
    }

    return 'overview'
}

function getCommentsTabIdFromPathname(pathname) {
    if (!pathname.startsWith('/dashboard/comments')) {
        return 'all'
    }

    const [, , , commentsTabId] = pathname.split('/')

    if (!commentsTabId || commentsTabId === 'all') {
        return 'all'
    }

    return COMMENTS_DASHBOARD_TAB_ID_BY_PATH_SEGMENT[commentsTabId] || 'all'
}

function getMetricsTabIdFromPathname(pathname) {
    if (!pathname.startsWith('/dashboard/metrics')) {
        return 'value-message'
    }

    const [, , , metricsTabPathSegment] = pathname.split('/')

    return METRICS_DASHBOARD_TAB_ID_BY_PATH_SEGMENT[metricsTabPathSegment] || 'value-message'
}

function getMetricsScenarioSlugFromPathname(pathname) {
    if (!pathname.startsWith('/dashboard/metrics/tpp')) {
        return null
    }

    const [, , , , metricsScenarioSlug] = pathname.split('/')

    return metricsScenarioSlug || null
}

function getDashboardPath(
    tabId,
    { commentsTabId = 'all', metricsTabId = 'value-message', metricsScenarioSlug = null } = {}
) {
    if (tabId === 'metrics') {
        const metricsTabPathSegment = METRICS_DASHBOARD_PATH_SEGMENT_BY_TAB_ID[metricsTabId] || 'value-message'

        if (metricsTabId === 'tpp') {
            return metricsScenarioSlug
                ? `/dashboard/metrics/${metricsTabPathSegment}/${metricsScenarioSlug}`
                : `/dashboard/metrics/${metricsTabPathSegment}`
        }

        return `/dashboard/metrics/${metricsTabPathSegment}`
    }

    if (tabId === 'comments') {
        const commentsTabPathSegment = COMMENTS_DASHBOARD_PATH_SEGMENT_BY_TAB_ID[commentsTabId] || 'all'

        return commentsTabPathSegment === 'all'
            ? '/dashboard/comments'
            : `/dashboard/comments/${commentsTabPathSegment}`
    }

    return '/dashboard'
}

function mapDispatchToProps(dispatch) {
    return {
        setStrategy: (strat) => dispatch(setStrategy(strat)),
        setUserRecord: (userRecord) => dispatch(setUserRecord(userRecord)),
    }
}

function DashboardHeader({
    strategy,
    editing,
    snapshotMode,
    userReadonly,
    handleCancel,
    savePositioningStatement,
    handleEditOpen,
    hideEditButton = false,
}) {
    return (
        <Grid container item wrap="nowrap" justifyContent="left" spacing={1.5} alignItems="baseline" sx={{ mb: 4 }}>
            <Grid item>
                <SvgIcon component={MapIcon} />
            </Grid>

            <Grid item xs>
                <Typography variant="h1">
                    {strategy.product} for {strategy.indication}
                </Typography>
            </Grid>

            <Grid container item xs="auto" alignItems="center" justifyContent="flex-end">
                {editing ? (
                    <>
                        <Button
                            aria-label="cancel"
                            autoFocus
                            variant="outlined"
                            onClick={handleCancel}
                            color="primary"
                            sx={{ mr: 1 }}
                        >
                            Cancel
                        </Button>
                        <Button
                            aria-label="save"
                            autoFocus
                            variant="contained"
                            color="primary"
                            onClick={savePositioningStatement}
                        >
                            Save
                        </Button>
                    </>
                ) : (
                    !snapshotMode &&
                    !userReadonly && (
                        <Button
                            id="edit-button"
                            variant="contained"
                            disableFocusRipple
                            disableRipple
                            startIcon={<SvgIcon component={PencilIcon} alt="Pencil Icon" inheritViewBox />}
                            onClick={hideEditButton ? undefined : handleEditOpen}
                            disabled={hideEditButton}
                            style={{
                                width: 168,
                                height: 52,
                                borderRadius: 14,
                                // Keep space identical but avoid any layout shift
                                visibility: hideEditButton ? 'hidden' : 'visible',
                            }}
                        >
                            Edit
                        </Button>
                    )
                )}
            </Grid>
        </Grid>
    )
}

function DashboardOverviewTab(props) {
    const {
        isDarkMode,
        isEditingPhaseTitle,
        setIsEditingPhaseTitle,
        editedPhaseTitlePosition,
        setEditedPhaseTitlePosition,
        hoveredFieldId,
        setHoveredFieldId,
        onCountryChange,
        handleNewMarket,
        classes,
        newKeyMarketPhase,
        setNewKeyMarketPhase,
        newPositioningStatement,
        setNewPositioningStatement,
        positioningStatement,
        filteredAnchors,
        Item,
        newKeyMarkets,
        setNewKeyMarkets,
        openEdit,
        handleEditCancel,
        handleEditSave,

        handleTPPClose,
        openTPP,
        newTPP,
        snapshotMode,
        userReadonly,
        setNewTPP,
        handleFileChange,
        uploading,
        uploadingFileName,
        uploadStatus,
        TPPFiles,
        handleDownloadStrategicAnchorFile,
        setOpenDeleteModal,
        setToDelete,
        handleTPPSave,

        handleCompetitiveClose,
        openCompetitiveLandscape,
        newCompetitiveLandscapes,
        setNewCompetitiveLandscapes,
        handleCompetitiveLandscapeSave,
        competitiveLandscapeFiles,

        handleCriticalSuccessClose,
        openCriticalSuccess,
        newCriticalSuccessFactors,
        setNewCriticalSuccessFactors,
        newCriticalSuccessFactor,
        setNewCriticalSuccessFactor,
        buildCriticalSuccessFactorMap,
        criticalSuccessFactorsMap,
        updateCriticalSuccessFactorsMap,
        criticalSuccessFactorsFiles,
        handleCriticalSuccessSave,
        setCriticalSuccessFactorsMap,

        handleFifthButtonClickClose,
        open5thButton,
        newFifthButtonItem,
        setNewFifthButtonItem,
        newFifthButtonValues,
        setNewFifthButtonValues,
        buildFifthButtonValuesMap,
        fifthButtonMap,
        updateFifthButtonValuesMap,
        setFifthButtonMap,
        optionalFifthBoxFiles,
        handleFifthButtonsSave,

        openMarket,
        handleMarketClose,
        newMarketAccessGoalText,
        setNewMarketAccessGoalText,
        newMarketAccessGoals,
        setNewMarketAccessGoals,
        buildMarketAccessGoalMap,
        marketAccessGoalsMap,
        setMarketAccessGoalsMap,
        marketAccessGoalsFiles,
        handleMarketSave,

        openDeleteModal,
        toDelete,
        removeFile,
    } = props

    const valuePropositionDisplayName = props?.valuePropositionDisplayName ?? {}

    return (
        <>
            <Grid container item justifyContent="flex-start" alignItems="flex-start" spacing={3}>
                <Grid container item spacing={3} justifyContent="flex-start" alignItems="flex-start">
                    <Grid container item direction="column" spacing={3} xs={12} md={6}>
                        <Grid item>
                            <Typography variant="h2">{valuePropositionDisplayName?.singular || 'Loading'}</Typography>
                        </Grid>
                        <Grid item>
                            <Typography variant="body1" sx={{ whiteSpace: 'break-spaces' }}>
                                {positioningStatement}
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container item xs={12} md={6} spacing={3}>
                        <Grid item>
                            <Typography variant="h2">Strategic Anchors</Typography>
                        </Grid>
                        <Grid container item spacing={3}>
                            {filteredAnchors.map((anchor, i) => (
                                <Grid item xs={6}>
                                    <Item component={Paper} sx={{ border: 1, borderColor: 'white', borderRadius: 3 }}>
                                        <Grid
                                            container
                                            alignItems="center"
                                            justifyContent="space-between"
                                            wrap="nowrap"
                                        >
                                            <Grid item>
                                                <Typography variant="h5">{anchor.title}</Typography>
                                            </Grid>
                                            <Grid item>
                                                <IconButton aria-label="see more" onClick={anchor.action}>
                                                    <ArrowForwardIosIcon
                                                        color="secondary"
                                                        sx={{
                                                            '&:hover': {
                                                                color: 'primary',
                                                            },
                                                        }}
                                                    />
                                                </IconButton>
                                            </Grid>
                                        </Grid>
                                    </Item>
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container item spacing={3} direction="column">
                    <Grid item xs={12}>
                        <Typography variant="h2">Key Markets & Target Launch Dates</Typography>
                    </Grid>
                    <EditableMarketList items={newKeyMarkets} updateMaster={setNewKeyMarkets} />
                </Grid>
            </Grid>
            <Dialog
                onClose={handleEditCancel}
                aria-labelledby="product-dialog-box"
                open={openEdit}
                fullWidth
                maxWidth="lg"
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    <Typography variant="h1">Product Details</Typography>
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleEditCancel}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <Grid container spacing={2}>
                        <Grid container item direction="column">
                            <Grid item>
                                <Typography variant="h2">
                                    {valuePropositionDisplayName?.singular || 'Loading'}
                                </Typography>
                            </Grid>
                            <Grid item>
                                <TextField
                                    id="positioning-statement"
                                    multiline
                                    variant="outlined"
                                    hiddenLabel
                                    fullWidth
                                    minRows={4}
                                    placeholder={positioningStatement}
                                    value={newPositioningStatement}
                                    onFocus={(event) => {
                                        event.target.setAttribute('autocomplete', 'off')
                                    }}
                                    onChange={(e) => setNewPositioningStatement(e.target.value)}
                                />
                            </Grid>
                        </Grid>
                        <Grid container item direction="column">
                            <Grid item mb={2}>
                                <Typography variant="h2">Key Markets & Target Launch Dates</Typography>
                            </Grid>
                            <Grid item>
                                <TextField
                                    id="new-phase"
                                    variant="outlined"
                                    fullWidth
                                    InputProps={
                                        newKeyMarketPhase.length > 0
                                            ? {
                                                  endAdornment: (
                                                      <InputAdornment
                                                          position="end"
                                                          onClick={() => {
                                                              let newArr = Array.from(newKeyMarkets)
                                                              newArr.push({
                                                                  phaseTitle: newKeyMarketPhase,
                                                                  phaseKeyMarkets: [],
                                                              })
                                                              setNewKeyMarkets(newArr)
                                                              setNewKeyMarketPhase('')
                                                          }}
                                                      >
                                                          <SvgIcon component={AddCircle} color="primary" />
                                                      </InputAdornment>
                                                  ),
                                              }
                                            : {}
                                    }
                                    onChange={(e) => setNewKeyMarketPhase(e.target.value)}
                                    value={newKeyMarketPhase}
                                    label="Add new phase"
                                />
                            </Grid>
                        </Grid>
                        <Grid container item xs spacing={2}>
                            {newKeyMarkets.map((phase, i) => (
                                <Grid
                                    item
                                    xs={6}
                                    sx={{
                                        backgroundColor: isDarkMode ? '#1A2027' : '',
                                    }}
                                >
                                    {/* -----------  PHASE TITLE -----------    */}

                                    {isEditingPhaseTitle && i === editedPhaseTitlePosition ? (
                                        <Grid container item direction="column">
                                            <Grid item>
                                                <Typography variant="subtitle3">Edit phase title</Typography>
                                            </Grid>
                                            <Grid item>
                                                <TextField
                                                    id="new-phase-title"
                                                    variant="filled"
                                                    fullWidth
                                                    size="small"
                                                    onChange={(e) => {
                                                        let newArr = Array.from(newKeyMarkets)
                                                        newArr.splice(i, 1, {
                                                            phaseTitle: e.target.value,
                                                            phaseKeyMarkets: newKeyMarkets[i].phaseKeyMarkets,
                                                        })
                                                        setNewKeyMarkets(newArr)
                                                    }}
                                                    value={newKeyMarkets[i].phaseTitle}
                                                    onMouseEnter={() => setHoveredFieldId(`phaseTitle-${i}`)}
                                                    onMouseLeave={() => setHoveredFieldId(null)}
                                                    InputProps={{
                                                        endAdornment:
                                                            hoveredFieldId === `phaseTitle-${i}` ? (
                                                                <>
                                                                    <InputAdornment position="end">
                                                                        <IconButton
                                                                            color="primary"
                                                                            aria-label="save"
                                                                            onClick={() => {
                                                                                setEditedPhaseTitlePosition(null)
                                                                                setIsEditingPhaseTitle(false)
                                                                            }}
                                                                        >
                                                                            <SvgIcon component={Check} />
                                                                        </IconButton>
                                                                    </InputAdornment>
                                                                    <InputAdornment position="end">
                                                                        <IconButton
                                                                            color="primary"
                                                                            aria-label="delete"
                                                                            onClick={() => {
                                                                                let newArr = Array.from(newKeyMarkets)
                                                                                newArr.splice(i, 1)
                                                                                setNewKeyMarkets(newArr)
                                                                                setIsEditingPhaseTitle(false)
                                                                                setEditedPhaseTitlePosition(null)
                                                                            }}
                                                                        >
                                                                            <SvgIcon component={DeleteBin} />
                                                                        </IconButton>
                                                                    </InputAdornment>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <InputAdornment position="end">
                                                                        <IconButton
                                                                            color="#C2E0FF"
                                                                            aria-label="save"
                                                                            onClick={() => {
                                                                                setEditedPhaseTitlePosition(null)
                                                                                setIsEditingPhaseTitle(false)
                                                                            }}
                                                                        >
                                                                            <SvgIcon component={Check} />
                                                                        </IconButton>
                                                                    </InputAdornment>
                                                                    <InputAdornment position="end">
                                                                        <IconButton
                                                                            aria-label="delete"
                                                                            color="#C2E0FF"
                                                                            onClick={() => {
                                                                                let newArr = Array.from(newKeyMarkets)
                                                                                newArr.splice(i, 1)
                                                                                setNewKeyMarkets(newArr)
                                                                                setIsEditingPhaseTitle(false)
                                                                                setEditedPhaseTitlePosition(null)
                                                                            }}
                                                                        >
                                                                            <SvgIcon component={DeleteBin} />
                                                                        </IconButton>
                                                                    </InputAdornment>
                                                                </>
                                                            ),
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>
                                    ) : (
                                        <Grid container item alignItems="center" spacing={1}>
                                            <Grid item>
                                                <Typography variant="h3" color="secondary">
                                                    {phase.phaseTitle}
                                                </Typography>
                                            </Grid>
                                            {!isEditingPhaseTitle && (
                                                <Grid item>
                                                    <IconButton
                                                        variant="contained"
                                                        aria-label="edit"
                                                        onClick={() => {
                                                            setIsEditingPhaseTitle(true)
                                                            setEditedPhaseTitlePosition(i)
                                                        }}
                                                    >
                                                        <SvgIcon
                                                            fontSize="small"
                                                            component={PencilIcon}
                                                            color="primary"
                                                        />
                                                    </IconButton>
                                                </Grid>
                                            )}
                                        </Grid>
                                    )}
                                    {i === editedPhaseTitlePosition && (
                                        <Grid container item xs>
                                            <Grid item>
                                                <Typography variant="subtitle3">Add/Remove key markets</Typography>
                                            </Grid>
                                            <Autocomplete
                                                id="combo-box"
                                                options={countries}
                                                autoHighlight
                                                selectOnFocus
                                                clearOnBlur
                                                fullWidth
                                                handleHomeEndKeys
                                                getOptionLabel={(option) => option.label}
                                                onChange={onCountryChange}
                                                classes={{
                                                    clearIndicatorDirty: classes.clearIndicator,
                                                    popupIndicator: classes.popupIndicator,
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        focused
                                                        label="Select '+' to add to the list"
                                                        onMouseEnter={() => setHoveredFieldId(`country-${i}`)}
                                                        onMouseLeave={() => setHoveredFieldId(null)}
                                                        {...params}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                handleNewMarket(e)
                                                            }
                                                        }}
                                                        variant="standard"
                                                        InputProps={{
                                                            ...params.InputProps,
                                                            endAdornment:
                                                                hoveredFieldId === `country-${i}` ? (
                                                                    <InputAdornment
                                                                        position="end"
                                                                        onClick={handleNewMarket}
                                                                    >
                                                                        <SvgIcon
                                                                            component={AddCircle}
                                                                            color="primary"
                                                                        />
                                                                    </InputAdornment>
                                                                ) : null,
                                                        }}
                                                        onFocus={(event) => {
                                                            event.target.setAttribute('autocomplete', 'off')
                                                        }}
                                                    />
                                                )}
                                                renderOption={(props, option) => (
                                                    <Box
                                                        component="li"
                                                        sx={{
                                                            '& > img': {
                                                                mr: 4,
                                                                flexShrink: 0,
                                                            },
                                                        }}
                                                        {...props}
                                                    >
                                                        <ReactCountryFlag
                                                            countryCode={option.code?.toLowerCase()}
                                                            svg
                                                            cdnUrl="https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/1x1/"
                                                            cdnSuffix="svg"
                                                            style={{
                                                                width: '1.3em',
                                                                height: '1.3em',
                                                                margin: '10px',
                                                            }}
                                                            className="countryFlagList"
                                                        />
                                                        {option.label}
                                                    </Box>
                                                )}
                                            />
                                        </Grid>
                                    )}
                                    {/* -----------  PHASE MARKETS -----------    */}
                                    <Grid container item>
                                        <Table>
                                            <TableBody>
                                                {phase.phaseKeyMarkets.map((market, j) => (
                                                    <StyledTableRow tabIndex={-1} key={market + j}>
                                                        <Grid
                                                            container
                                                            item
                                                            alignItems="center"
                                                            p={1}
                                                            justifyContent="space-between"
                                                        >
                                                            <Grid
                                                                container
                                                                item
                                                                wrap="noWrap"
                                                                alignItems="center"
                                                                xs={6}
                                                            >
                                                                <Grid item>
                                                                    <ReactCountryFlag
                                                                        countryCode={market.code?.toLowerCase()}
                                                                        svg
                                                                        cdnUrl="https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/1x1/"
                                                                        cdnSuffix="svg"
                                                                        style={{
                                                                            width: '1.7em',
                                                                            height: '1.7em',
                                                                            margin: '2px',
                                                                        }}
                                                                        title={market.code}
                                                                        className="countryFlag"
                                                                    />
                                                                </Grid>
                                                                <Grid item xs zeroMinWidth>
                                                                    <Typography
                                                                        variant="body1"
                                                                        noWrap
                                                                        color="secondary"
                                                                    >
                                                                        {market.label}
                                                                    </Typography>
                                                                </Grid>
                                                            </Grid>
                                                            {isEditingPhaseTitle && i === editedPhaseTitlePosition ? (
                                                                <Grid
                                                                    container
                                                                    item
                                                                    xs={4}
                                                                    wrap="noWrap"
                                                                    alignItems="center"
                                                                >
                                                                    <Grid item>
                                                                        <TextField
                                                                            id="new-target-launch-date"
                                                                            variant="standard"
                                                                            onChange={(e) => {
                                                                                let newArr = Array.from(newKeyMarkets)
                                                                                let newMarketArr = Array.from(
                                                                                    newKeyMarkets[i].phaseKeyMarkets
                                                                                )
                                                                                newMarketArr.splice(j, 1, {
                                                                                    code: market.code,
                                                                                    label: market.label,
                                                                                    targetLaunchDate: e.target.value,
                                                                                })
                                                                                newArr.splice(i, 1, {
                                                                                    phaseTitle:
                                                                                        newKeyMarkets[i].phaseTitle,
                                                                                    phaseKeyMarkets: newMarketArr,
                                                                                })
                                                                                setNewKeyMarkets(newArr)
                                                                            }}
                                                                            value={
                                                                                newKeyMarkets[i].phaseKeyMarkets[j]
                                                                                    .targetLaunchDate
                                                                            }
                                                                            label={
                                                                                <Typography variant="subtitle3">
                                                                                    Target Launch Date
                                                                                </Typography>
                                                                            }
                                                                        />
                                                                    </Grid>
                                                                </Grid>
                                                            ) : (
                                                                <Grid item>
                                                                    <Typography variant="body2">
                                                                        {market.targetLaunchDate}
                                                                    </Typography>
                                                                </Grid>
                                                            )}
                                                            <Grid item>
                                                                <IconButton
                                                                    aria-label="delete"
                                                                    onClick={() => {
                                                                        let newArr = Array.from(newKeyMarkets)
                                                                        let newMarketArr = Array.from(
                                                                            newKeyMarkets[i].phaseKeyMarkets
                                                                        )
                                                                        newMarketArr.splice(j, 1)
                                                                        newArr.splice(i, 1, {
                                                                            phaseTitle: newKeyMarkets[i].phaseTitle,
                                                                            phaseKeyMarkets: newMarketArr,
                                                                        })
                                                                        setNewKeyMarkets(newArr)
                                                                    }}
                                                                >
                                                                    <SvgIcon component={CancelOutlined} />
                                                                </IconButton>
                                                            </Grid>
                                                        </Grid>
                                                    </StyledTableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </Grid>
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button autoFocus variant="outlined" onClick={handleEditCancel} color="primary">
                        Cancel
                    </Button>
                    <Button autoFocus variant="contained" onClick={handleEditSave} color="primary">
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                onClose={handleTPPClose}
                aria-labelledby="customized-dialog-title-tpp"
                open={openTPP}
                fullWidth
                maxWidth="lg"
            >
                <DialogTitle id="customized-dialog-title-tpp">
                    <Typography variant="h3">
                        {_.isEmpty(store.getState().settings) ? '' : store.getState().settings.displayNames.tpp}
                    </Typography>
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container item spacing={2}>
                        {newTPP.map((row, i) => (
                            <Grid container item key={'tppRow' + i} direction="column" xs={6}>
                                <Grid item>
                                    <Typography variant="title2">{newTPP[i]['displayText']}</Typography>
                                </Grid>
                                <Grid item>
                                    <TextField
                                        id={'TPP' + i}
                                        disabled={snapshotMode || userReadonly}
                                        multiline
                                        fullWidth
                                        value={newTPP[i]['value']}
                                        onFocus={(event) => {
                                            event.target.setAttribute('autocomplete', 'off')
                                        }}
                                        onChange={(e) => {
                                            let newArr = Array.from(newTPP)
                                            newArr.splice(i, 1, {
                                                displayText: newTPP[i].displayText,
                                                value: e.target.value,
                                            })
                                            setNewTPP(newArr)
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        ))}
                    </Grid>
                    <Grid container alignItems="center">
                        <Grid container item alignItems="center">
                            <Grid item>
                                <Typography variant="title2">Files</Typography>
                            </Grid>
                            {!userReadonly && !snapshotMode && (
                                <Grid item>
                                    <IconButton component="label">
                                        <input
                                            id="file-upload"
                                            type="file"
                                            hidden
                                            onChange={(e) => handleFileChange(e, 'TPP')}
                                            multiple
                                        />
                                        <SvgIcon component={AddCircle} color="primary" inheritViewBox />
                                    </IconButton>
                                </Grid>
                            )}
                            <Grid container item>
                                {uploading && (
                                    <Grid item>
                                        <Box sx={{ width: '100%', mt: 2 }}>
                                            <LinearProgress />
                                            <Typography variant="body2" sx={{ mt: 1 }}>
                                                Uploading {uploadingFileName}...
                                            </Typography>
                                        </Box>
                                    </Grid>
                                )}
                                {uploadStatus && uploadStatus.severity === 'error' && (
                                    <Alert severity={uploadStatus.severity} sx={{ mt: 2 }}>
                                        {uploadStatus.message}
                                    </Alert>
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid container item>
                        {!TPPFiles.length && !uploading && (
                            <Grid container>
                                <Typography variant="subtitle2">None</Typography>
                            </Grid>
                        )}
                        {TPPFiles.map((file, i) => (
                            <Grid container spacing={1} alignItems="center" wrap="nowrap">
                                <Grid item xs="auto">
                                    <Typography variant="chip">{i + 1}.</Typography>
                                </Grid>
                                <Grid item xs="auto">
                                    <Chip
                                        icon={<Logo />}
                                        label={<Typography variant="chip">{file.originalFileName}</Typography>}
                                    />
                                </Grid>
                                <Grid container item spacing={1} xs="auto">
                                    <Grid item xs="auto">
                                        <GetAppIcon
                                            sx={{
                                                color: 'figma.primary',
                                                cursor: 'pointer',
                                            }}
                                            onClick={() => handleDownloadStrategicAnchorFile('TPP', i)}
                                        />
                                    </Grid>
                                    <Grid item xs="auto">
                                        {!userReadonly && !snapshotMode && (
                                            <IconButton
                                                aria-label="delete"
                                                size="small"
                                                onClick={() => {
                                                    setOpenDeleteModal(true)
                                                    setToDelete([file.s3Name, file.atlasFileType])
                                                }}
                                            >
                                                <SvgIcon component={DeleteBin} alt="Delete Trashcan" inheritViewBox />
                                            </IconButton>
                                        )}
                                    </Grid>
                                </Grid>
                            </Grid>
                        ))}
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={handleTPPClose} variant="outlined" color="primary" disabled={uploading}>
                        {snapshotMode || userReadonly ? 'Close' : 'Cancel'}
                    </Button>
                    {!snapshotMode && !userReadonly && (
                        <Button
                            autoFocus
                            onClick={handleTPPSave}
                            variant="contained"
                            color="primary"
                            disabled={uploading}
                        >
                            Save
                        </Button>
                    )}
                </DialogActions>
            </Dialog>
            <Dialog
                fullWidth
                maxWidth="lg"
                onClose={handleCompetitiveClose}
                aria-labelledby="customized-dialog-title-competitive"
                open={openCompetitiveLandscape}
            >
                <DialogTitle id="customized-dialog-title-competitive">
                    <Typography variant="h3">
                        {store.getState().settings?.displayNames?.competitiveLandscape || 'Loading'}
                    </Typography>
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container item spacing={2}>
                        {Object.keys(newCompetitiveLandscapes).map((row, i) => (
                            <Grid container item key={'compRow' + i} direction="column" xs={6}>
                                <Grid item>
                                    <Typography variant="title2">
                                        {newCompetitiveLandscapes[row]['displayText']}
                                    </Typography>
                                </Grid>
                                <Grid item>
                                    <TextField
                                        id={'comp' + i}
                                        disabled={snapshotMode || userReadonly}
                                        multiline
                                        fullWidth
                                        placeholder={
                                            !snapshotMode && !userReadonly && newCompetitiveLandscapes[i]['placeholder']
                                        }
                                        value={newCompetitiveLandscapes[i]['value']}
                                        onFocus={(event) => {
                                            event.target.setAttribute('autocomplete', 'off')
                                        }}
                                        onChange={(e) => {
                                            let newArr = Array.from(newCompetitiveLandscapes)
                                            newArr.splice(i, 1, {
                                                displayText: newCompetitiveLandscapes[i].displayText,
                                                value: e.target.value,
                                                placeholder: newCompetitiveLandscapes[i].placeholder,
                                            })
                                            setNewCompetitiveLandscapes(newArr)
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        ))}
                    </Grid>
                    <Grid container alignItems="center">
                        <Grid container item alignItems="center">
                            <Grid item>
                                <Typography variant="title2">Files</Typography>
                            </Grid>
                            {!userReadonly && !snapshotMode && (
                                <Grid item>
                                    <IconButton component="label">
                                        <input
                                            id="file-upload"
                                            type="file"
                                            hidden
                                            onChange={(e) => handleFileChange(e, 'competitiveLandscape')}
                                            multiple
                                        />
                                        <SvgIcon component={AddCircle} color="primary" inheritViewBox />
                                    </IconButton>
                                </Grid>
                            )}
                            <Grid container item>
                                {uploading && (
                                    <Grid item>
                                        <Box sx={{ width: '100%', mt: 2 }}>
                                            <LinearProgress />
                                            <Typography variant="body2" sx={{ mt: 1 }}>
                                                Uploading {uploadingFileName}...
                                            </Typography>
                                        </Box>
                                    </Grid>
                                )}
                                {uploadStatus && uploadStatus.severity === 'error' && (
                                    <Alert severity={uploadStatus.severity} sx={{ mt: 2 }}>
                                        {uploadStatus.message}
                                    </Alert>
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid container item>
                        {!competitiveLandscapeFiles.length && !uploading && (
                            <Grid container>
                                <Typography variant="subtitle2">None</Typography>
                            </Grid>
                        )}
                        {competitiveLandscapeFiles.map((file, i) => (
                            <Grid container spacing={1} alignItems="center" wrap="nowrap">
                                <Grid item xs="auto">
                                    <Typography variant="chip">{i + 1}.</Typography>
                                </Grid>
                                <Grid item xs="auto">
                                    <Chip
                                        icon={<Logo />}
                                        label={<Typography variant="chip">{file.originalFileName}</Typography>}
                                    />
                                </Grid>
                                <Grid container item spacing={1} xs="auto">
                                    <Grid item xs="auto">
                                        <GetAppIcon
                                            sx={{
                                                color: 'figma.primary',
                                                cursor: 'pointer',
                                            }}
                                            onClick={() => handleDownloadStrategicAnchorFile('competitiveLandscape', i)}
                                        />
                                    </Grid>
                                    <Grid item xs="auto">
                                        {!userReadonly && !snapshotMode && (
                                            <IconButton
                                                aria-label="delete"
                                                size="small"
                                                onClick={() => {
                                                    setOpenDeleteModal(true)
                                                    setToDelete([file.s3Name, file.atlasFileType])
                                                }}
                                            >
                                                <SvgIcon component={DeleteBin} alt="Delete Trashcan" inheritViewBox />
                                            </IconButton>
                                        )}
                                    </Grid>
                                </Grid>
                            </Grid>
                        ))}
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button
                        autoFocus
                        onClick={handleCompetitiveClose}
                        variant="outlined"
                        color="primary"
                        disabled={uploading}
                    >
                        {snapshotMode || userReadonly ? 'Close' : 'Cancel'}
                    </Button>
                    {!snapshotMode && !userReadonly && (
                        <Button
                            autoFocus
                            onClick={handleCompetitiveLandscapeSave}
                            variant="contained"
                            color="primary"
                            disabled={uploading}
                        >
                            Save
                        </Button>
                    )}
                </DialogActions>
            </Dialog>
            <Dialog
                fullWidth
                maxWidth="lg"
                onClose={handleCriticalSuccessClose}
                aria-labelledby="customized-dialog-title-critical-success"
                open={openCriticalSuccess}
            >
                <DialogTitle id="customized-dialog-title-critical-success">
                    <Typography variant="h3">
                        {store.getState().settings?.displayNames?.criticalSuccessFactors || 'Loading'}
                    </Typography>
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container direction="column" spacing={2}>
                        <Grid item xs>
                            <TextField
                                id="new-crit-success"
                                variant="outlined"
                                disabled={snapshotMode || userReadonly}
                                placeholder={!snapshotMode && !userReadonly && "Press 'Enter' to Add A New Line Item"}
                                fullWidth
                                value={newCriticalSuccessFactor}
                                onChange={(e) => setNewCriticalSuccessFactor(e.target.value)}
                                onFocus={(event) => {
                                    event.target.setAttribute('autocomplete', 'off')
                                }}
                                onKeyPress={(e) => {
                                    if (e.key === 'Enter') {
                                        let newArr = Array.from(newCriticalSuccessFactors)
                                        newArr.push(newCriticalSuccessFactor)
                                        setNewCriticalSuccessFactors(newArr)
                                        setNewCriticalSuccessFactor('')
                                        buildCriticalSuccessFactorMap(newArr)
                                    }
                                }}
                            />
                        </Grid>
                        <Grid container item xs direction="column" spacing={1}>
                            {newCriticalSuccessFactors.map((row, i) => (
                                <Grid
                                    container
                                    item
                                    xs
                                    alignItems="center"
                                    justifyContent="space-between"
                                    spacing={2}
                                    wrap="nowrap"
                                >
                                    <Grid item>
                                        <Typography variant="title2">{i + 1 + '.'}</Typography>
                                    </Grid>
                                    <Grid item xs>
                                        <TextField
                                            id={'crit-success-' + i}
                                            disabled={snapshotMode || userReadonly}
                                            multiline
                                            fullWidth
                                            variant="filled"
                                            value={criticalSuccessFactorsMap[row]}
                                            onFocus={(event) => {
                                                event.target.setAttribute('autocomplete', 'off')
                                            }}
                                            onChange={(e) => {
                                                updateCriticalSuccessFactorsMap(e.target.value, row)
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs="auto">
                                        {!snapshotMode && !userReadonly && (
                                            <IconButton>
                                                <ClearIcon
                                                    onClick={() => {
                                                        let newMap = {
                                                            ...criticalSuccessFactorsMap,
                                                        }
                                                        delete newMap[row]
                                                        setCriticalSuccessFactorsMap(newMap)
                                                        let newArr = Array.from(newCriticalSuccessFactors)
                                                        newArr.splice(i, 1)
                                                        setNewCriticalSuccessFactors(newArr)
                                                    }}
                                                />
                                            </IconButton>
                                        )}
                                    </Grid>
                                </Grid>
                            ))}
                        </Grid>
                        <Grid container alignItems="center">
                            <Grid item ml={2}>
                                <Typography variant="title2">Files</Typography>
                            </Grid>
                            {!userReadonly && !snapshotMode && (
                                <Grid item>
                                    <IconButton component="label">
                                        <input
                                            id="file-upload"
                                            type="file"
                                            hidden
                                            onChange={(e) => handleFileChange(e, 'criticalSuccessFactors')}
                                            multiple
                                        />
                                        <SvgIcon component={AddCircle} color="primary" inheritViewBox />
                                    </IconButton>
                                </Grid>
                            )}
                            <Grid container item>
                                {uploading && (
                                    <Grid item>
                                        <Box sx={{ width: '100%', mt: 2 }}>
                                            <LinearProgress />
                                            <Typography variant="body2" sx={{ mt: 1 }}>
                                                Uploading {uploadingFileName}...
                                            </Typography>
                                        </Box>
                                    </Grid>
                                )}
                                {uploadStatus && uploadStatus.severity === 'error' && (
                                    <Alert severity={uploadStatus.severity} sx={{ mt: 2 }}>
                                        {uploadStatus.message}
                                    </Alert>
                                )}
                            </Grid>
                        </Grid>
                        <Grid container item>
                            {!criticalSuccessFactorsFiles.length && !uploading && (
                                <Grid container>
                                    <Typography variant="subtitle2">None</Typography>
                                </Grid>
                            )}
                            {criticalSuccessFactorsFiles.map((file, i) => (
                                <Grid container spacing={1} alignItems="center" wrap="nowrap">
                                    <Grid item xs="auto">
                                        <Typography variant="chip">{i + 1}.</Typography>
                                    </Grid>
                                    <Grid item xs="auto">
                                        <Chip
                                            icon={<Logo />}
                                            label={<Typography variant="chip">{file.originalFileName}</Typography>}
                                        />
                                    </Grid>
                                    <Grid container item spacing={1} xs="auto">
                                        <Grid item xs="auto">
                                            <GetAppIcon
                                                sx={{
                                                    color: 'figma.primary',
                                                    cursor: 'pointer',
                                                }}
                                                onClick={() =>
                                                    handleDownloadStrategicAnchorFile('criticalSuccessFactors', i)
                                                }
                                            />
                                        </Grid>
                                        <Grid item xs="auto">
                                            {!userReadonly && !snapshotMode && (
                                                <IconButton
                                                    aria-label="delete"
                                                    size="small"
                                                    onClick={() => {
                                                        setOpenDeleteModal(true)
                                                        setToDelete([file.s3Name, file.atlasFileType])
                                                    }}
                                                >
                                                    <SvgIcon
                                                        component={DeleteBin}
                                                        alt="Delete Trashcan"
                                                        inheritViewBox
                                                    />
                                                </IconButton>
                                            )}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button
                        autoFocus
                        onClick={handleCriticalSuccessClose}
                        variant="outlined"
                        color="primary"
                        disabled={uploading}
                    >
                        {snapshotMode || userReadonly ? 'Close' : 'Cancel'}
                    </Button>
                    {!snapshotMode && !userReadonly && (
                        <Button
                            autoFocus
                            onClick={handleCriticalSuccessSave}
                            variant="contained"
                            color="primary"
                            disabled={uploading}
                        >
                            Save
                        </Button>
                    )}
                </DialogActions>
            </Dialog>
            <Dialog
                fullWidth
                maxWidth="lg"
                onClose={handleMarketClose}
                aria-labelledby="customized-dialog-title-market"
                open={openMarket}
            >
                <DialogTitle id="customized-dialog-title-market">
                    <Typography variant="h3">
                        {(store.getState().settings?.displayNames?.marketAccessGoals &&
                            store.getState().settings?.displayNames?.marketAccessGoals) ||
                            'Loading'}
                    </Typography>
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={3}>
                        <Grid container item>
                            <TextField
                                id="new-mag"
                                disabled={snapshotMode || userReadonly}
                                placeholder={!snapshotMode && !userReadonly && "Press 'Enter' to Add New Item"}
                                fullWidth
                                value={newMarketAccessGoalText}
                                onChange={(e) => setNewMarketAccessGoalText(e.target.value)}
                                onFocus={(event) => {
                                    event.target.setAttribute('autocomplete', 'off')
                                }}
                                onKeyPress={(e) => {
                                    if (e.key === 'Enter') {
                                        let newArr = Array.from(newMarketAccessGoals)
                                        newArr.push({
                                            title: newMarketAccessGoalText,
                                            priority: 'medium',
                                            notes: '',
                                            summary: '',
                                            leverValue: '',
                                        })
                                        setNewMarketAccessGoals(newArr)
                                        setNewCriticalSuccessFactor('')
                                        setNewMarketAccessGoalText('')
                                        buildMarketAccessGoalMap(newArr)
                                    }
                                }}
                            />
                        </Grid>
                        <Grid container item spacing={1}>
                            {Object.keys(newMarketAccessGoals).map((row, i) => (
                                <Grid container item key={'compRow' + i} direction="column" xs={6} wrap="nowrap">
                                    <Grid container item spacing={1}>
                                        <Grid item>
                                            <Typography variant="title2">{i + 1 + '.'}</Typography>
                                        </Grid>
                                        <Grid item>
                                            <Typography variant="subtitle1">
                                                {newMarketAccessGoals[row].title}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid container alignItems="center">
                                        <Grid item xs>
                                            <TextField
                                                id={'goal' + i}
                                                disabled={snapshotMode || userReadonly}
                                                multiline
                                                fullWidth
                                                value={newMarketAccessGoals[i].summary}
                                                onChange={(e) => {
                                                    let newArr = Array.from(newMarketAccessGoals)
                                                    newArr.splice(i, 1, {
                                                        title: newMarketAccessGoals[i].title,
                                                        priority: newMarketAccessGoals[i].priority,
                                                        notes: newMarketAccessGoals[i].notes,
                                                        summary: e.target.value,
                                                        leverValue: newMarketAccessGoals[i].leverValue,
                                                    })
                                                    setNewMarketAccessGoals(newArr)
                                                }}
                                                onFocus={(event) => {
                                                    event.target.setAttribute('autocomplete', 'off')
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs="auto">
                                            {!snapshotMode && !userReadonly && (
                                                <IconButton>
                                                    <ClearIcon
                                                        onClick={() => {
                                                            let newMap = {
                                                                ...marketAccessGoalsMap,
                                                            }
                                                            delete newMap[row.title]
                                                            setMarketAccessGoalsMap(newMap)
                                                            let newArr = Array.from(newMarketAccessGoals)
                                                            newArr.splice(i, 1)
                                                            setNewMarketAccessGoals(newArr)
                                                        }}
                                                    />
                                                </IconButton>
                                            )}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            ))}
                        </Grid>
                        <Grid container alignItems="center">
                            <Grid container item alignItems="center">
                                <Grid item ml={2}>
                                    <Typography variant="title2">Files</Typography>
                                </Grid>
                                {!userReadonly && !snapshotMode && (
                                    <Grid item>
                                        <IconButton component="label">
                                            <input
                                                id="file-upload"
                                                type="file"
                                                hidden
                                                onChange={(e) => handleFileChange(e, 'marketAccessGoals')}
                                                multiple
                                            />
                                            <SvgIcon component={AddCircle} color="primary" inheritViewBox />
                                        </IconButton>
                                    </Grid>
                                )}
                                <Grid container item ml={2}>
                                    {uploading && (
                                        <Grid item>
                                            <Box sx={{ width: '100%', mt: 2 }}>
                                                <LinearProgress />
                                                <Typography variant="body2" sx={{ mt: 1 }}>
                                                    Uploading {uploadingFileName}...
                                                </Typography>
                                            </Box>
                                        </Grid>
                                    )}
                                    {uploadStatus && uploadStatus.severity === 'error' && (
                                        <Alert severity={uploadStatus.severity} sx={{ mt: 2 }}>
                                            {uploadStatus.message}
                                        </Alert>
                                    )}
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid container item>
                            {!marketAccessGoalsFiles.length && !uploading && (
                                <Grid container>
                                    <Typography variant="subtitle2">None</Typography>
                                </Grid>
                            )}
                            {marketAccessGoalsFiles.map((file, i) => (
                                <Grid container spacing={1} alignItems="center" wrap="nowrap">
                                    <Grid item xs="auto">
                                        <Typography variant="chip">{i + 1}.</Typography>
                                    </Grid>
                                    <Grid item xs="auto">
                                        <Chip
                                            icon={<Logo />}
                                            label={<Typography variant="chip">{file.originalFileName}</Typography>}
                                        />
                                    </Grid>
                                    <Grid container item spacing={1} xs="auto">
                                        <Grid item xs="auto">
                                            <GetAppIcon
                                                sx={{
                                                    color: 'figma.primary',
                                                    cursor: 'pointer',
                                                }}
                                                onClick={() =>
                                                    handleDownloadStrategicAnchorFile('marketAccessGoals', i)
                                                }
                                            />
                                        </Grid>
                                        <Grid item xs="auto">
                                            {!userReadonly && !snapshotMode && (
                                                <IconButton
                                                    aria-label="delete"
                                                    size="small"
                                                    onClick={() => {
                                                        setOpenDeleteModal(true)
                                                        setToDelete([file.s3Name, file.atlasFileType])
                                                    }}
                                                >
                                                    <SvgIcon
                                                        component={DeleteBin}
                                                        alt="Delete Trashcan"
                                                        inheritViewBox
                                                    />
                                                </IconButton>
                                            )}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button
                        autoFocus
                        onClick={handleMarketClose}
                        variant="outlined"
                        color="primary"
                        disabled={uploading}
                    >
                        {snapshotMode || userReadonly ? 'Close' : 'Cancel'}
                    </Button>
                    {!snapshotMode && !userReadonly && (
                        <Button
                            autoFocus
                            onClick={handleMarketSave}
                            variant="contained"
                            color="primary"
                            disabled={uploading}
                        >
                            Save
                        </Button>
                    )}
                </DialogActions>
            </Dialog>
            <Dialog
                fullWidth
                maxWidth="lg"
                onClose={handleFifthButtonClickClose}
                aria-labelledby="customized-dialog-title-fifth"
                open={open5thButton}
            >
                <DialogTitle id="customized-dialog-title-fifth">
                    <Typography variant="h3">
                        {(store.getState().settings?.displayNames?.fifthBoxDashboard &&
                            store.getState().settings?.displayNames?.fifthBoxDashboard) ||
                            'Loading'}
                    </Typography>
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container direction="column" spacing={2}>
                        <Grid item xs>
                            <TextField
                                id="new-fifth-box"
                                variant="outlined"
                                disabled={snapshotMode || userReadonly}
                                placeholder={!snapshotMode && !userReadonly && "Press 'Enter' to Add A New Line Item"}
                                fullWidth
                                value={newFifthButtonItem}
                                onChange={(e) => setNewFifthButtonItem(e.target.value)}
                                onFocus={(event) => {
                                    event.target.setAttribute('autocomplete', 'off')
                                }}
                                onKeyPress={(e) => {
                                    if (e.key === 'Enter') {
                                        let newArr = Array.from(newFifthButtonValues)
                                        newArr.push(newFifthButtonItem)
                                        setNewFifthButtonValues(newArr)
                                        setNewFifthButtonItem('')
                                        buildFifthButtonValuesMap(newArr)
                                    }
                                }}
                            />
                        </Grid>
                        <Grid container item xs direction="column" spacing={1}>
                            {newFifthButtonValues.map((row, i) => (
                                <Grid
                                    container
                                    item
                                    xs
                                    alignItems="center"
                                    justifyContent="space-between"
                                    spacing={2}
                                    wrap="nowrap"
                                >
                                    <Grid item>
                                        <Typography variant="title2">{i + 1 + '.'}</Typography>
                                    </Grid>
                                    <Grid item xs>
                                        <TextField
                                            id={'fifth-' + i}
                                            disabled={snapshotMode || userReadonly}
                                            multiline
                                            fullWidth
                                            variant="filled"
                                            value={fifthButtonMap[row]}
                                            onFocus={(event) => {
                                                event.target.setAttribute('autocomplete', 'off')
                                            }}
                                            onChange={(e) => {
                                                updateFifthButtonValuesMap(e.target.value, row)
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs="auto">
                                        {!snapshotMode && !userReadonly && (
                                            <IconButton>
                                                <ClearIcon
                                                    onClick={() => {
                                                        let newMap = {
                                                            ...fifthButtonMap,
                                                        }
                                                        delete newMap[row]
                                                        setFifthButtonMap(newMap)
                                                        let newArr = Array.from(newFifthButtonValues)
                                                        newArr.splice(i, 1)
                                                        setNewFifthButtonValues(newArr)
                                                    }}
                                                />
                                            </IconButton>
                                        )}
                                    </Grid>
                                </Grid>
                            ))}
                        </Grid>
                        <Grid container alignItems="center">
                            <Grid container item alignItems="center">
                                <Grid item ml={2}>
                                    <Typography variant="title2">Files</Typography>
                                </Grid>
                                {!userReadonly && !snapshotMode && (
                                    <Grid item>
                                        <IconButton component="label">
                                            <input
                                                id="file-upload"
                                                type="file"
                                                hidden
                                                onChange={(e) => handleFileChange(e, 'optionalFifthBox')}
                                                multiple
                                            />
                                            <SvgIcon component={AddCircle} color="primary" inheritViewBox />
                                        </IconButton>
                                    </Grid>
                                )}
                                <Grid container item>
                                    {uploading && (
                                        <Grid item>
                                            <Box sx={{ width: '100%', mt: 2 }}>
                                                <LinearProgress />
                                                <Typography variant="body2" sx={{ mt: 1 }}>
                                                    Uploading {uploadingFileName}...
                                                </Typography>
                                            </Box>
                                        </Grid>
                                    )}
                                    {uploadStatus && uploadStatus.severity === 'error' && (
                                        <Alert severity={uploadStatus.severity} sx={{ mt: 2 }}>
                                            {uploadStatus.message}
                                        </Alert>
                                    )}
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid container item>
                            {!optionalFifthBoxFiles.length && !uploading && (
                                <Grid container>
                                    <Typography variant="subtitle2">None</Typography>
                                </Grid>
                            )}
                            {optionalFifthBoxFiles.map((file, i) => (
                                <Grid container spacing={1} alignItems="center" wrap="nowrap">
                                    <Grid item xs="auto">
                                        <Typography variant="chip">{i + 1}.</Typography>
                                    </Grid>
                                    <Grid item xs="auto">
                                        <Chip
                                            icon={<Logo />}
                                            label={<Typography variant="chip">{file.originalFileName}</Typography>}
                                        />
                                    </Grid>
                                    <Grid container item spacing={1} xs="auto">
                                        <Grid item xs="auto">
                                            <GetAppIcon
                                                sx={{
                                                    color: 'figma.primary',
                                                    cursor: 'pointer',
                                                }}
                                                onClick={() => handleDownloadStrategicAnchorFile('optionalFifthBox', i)}
                                            />
                                        </Grid>
                                        <Grid item xs="auto">
                                            {!userReadonly && !snapshotMode && (
                                                <IconButton
                                                    aria-label="delete"
                                                    size="small"
                                                    onClick={() => {
                                                        setOpenDeleteModal(true)
                                                        setToDelete([file.s3Name, file.atlasFileType])
                                                    }}
                                                >
                                                    <SvgIcon
                                                        component={DeleteBin}
                                                        alt="Delete Trashcan"
                                                        inheritViewBox
                                                    />
                                                </IconButton>
                                            )}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button
                        autoFocus
                        onClick={handleFifthButtonClickClose}
                        variant="outlined"
                        color="primary"
                        disabled={uploading}
                    >
                        {snapshotMode || userReadonly ? 'Close' : 'Cancel'}
                    </Button>
                    {!snapshotMode && !userReadonly && (
                        <Button
                            autoFocus
                            onClick={handleFifthButtonsSave}
                            variant="contained"
                            color="primary"
                            disabled={uploading}
                        >
                            Save
                        </Button>
                    )}
                </DialogActions>
            </Dialog>
            <Dialog
                open={openDeleteModal}
                onClose={() => setOpenDeleteModal(false)}
                aria-labelledby="alert-dialog-title4"
                aria-describedby="alert-dialog-description4"
            >
                <DialogTitle id="alert-dialog-slide-title2">
                    <Typography variant="h4">Confirm</Typography>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        <Typography variant="h4">Are you sure you want to delete this file?</Typography>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenDeleteModal(false)} variant="outlined">
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        onClick={() => {
                            if (toDelete && toDelete.length && toDelete.length === 2) {
                                removeFile(toDelete[0], toDelete[1])
                            } else {
                                console.log('Failed to set delete variable')
                            }
                            setOpenDeleteModal(false)
                        }}
                    >
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

function ConnectedDashboard(props) {
    const snapshotMode = useSelector((state) => (state.strategy ? !!state.strategy.sourceId : false))
    const userReadonly = useIsRoadmapReadonly()
    const isDarkMode = useSelector((state) =>
        !state.userRecord ? true : state?.userRecord?.isDarkMode === undefined ? true : state?.userRecord?.isDarkMode
    )

    const { user, getTokenSilently, isAuthenticated, isLoading, logout } = useAuth0()
    const history = useHistory()
    const classes = useStyles()
    const { logEvent, ACTIONS } = useEventLogger()
    const queryClient = useQueryClient()

    const [selectedFiles, setSelectedFiles] = useState([])

    const [openTPP, setOpenTPP] = useState(false)
    const [openCompetitiveLandscape, setOpenCompetitiveLandscape] = useState(false)
    const [openCriticalSuccess, setOpenCriticalSuccess] = useState(false)
    const [openSnapshot, setOpenSnapshot] = useState(false)
    const [openMarket, setOpenMarket] = useState(false)
    const [open5thButton, setOpen5thButton] = useState(false)
    const [openDeleteModal, setOpenDeleteModal] = useState(false)
    const [openEdit, setOpenEdit] = useState(false)

    const [newSnapshotNote, setNewSnapshotNote] = useState('')
    const [snapshotInProgress, setSnapshotInProgress] = useState(false)

    const [editing, setEditing] = useState(false)
    const [newPositioningStatement, setNewPositioningStatement] = useState('')
    const [positioningStatement, setPositioningStatement] = useState('')
    const [strategy, setStrat] = useState({})
    const [loaded, setLoaded] = useState(false)
    const [hoveredFieldId, setHoveredFieldId] = useState(null)
    const [authenticated, setAuthenticated] = useState(false)

    const [competitiveLandscape, setCompetitiveLandscape] = useState([])
    const [newCompetitiveLandscapes, setNewCompetitiveLandscapes] = useState([])
    const [keyMarkets, setKeyMarkets] = useState([])
    const [newKeyMarket, setNewKeyMarket] = useState({})
    const [newKeyMarkets, setNewKeyMarkets] = useState([])

    const [newKeyMarketPhase, setNewKeyMarketPhase] = useState('')
    const [isEditingPhaseTitle, setIsEditingPhaseTitle] = useState(false)
    const [editedPhaseTitlePosition, setEditedPhaseTitlePosition] = useState(null)

    const [strategicImperativeMap, setStrategicImperativeMap] = useState({})

    const [criticalSuccessFactors, setCriticalSuccessFactors] = useState([])
    const [newCriticalSuccessFactor, setNewCriticalSuccessFactor] = useState('')
    const [newCriticalSuccessFactors, setNewCriticalSuccessFactors] = useState([])
    const [criticalSuccessFactorsMap, setCriticalSuccessFactorsMap] = useState({})

    const [fifthButtonValues, setFifthButtonValues] = useState([])
    const [newFifthButtonValues, setNewFifthButtonValues] = useState([])
    const [newFifthButtonItem, setNewFifthButtonItem] = useState('')
    const [fifthButtonMap, setFifthButtonMap] = useState({})

    const [gapAnalysis, setGapAnalysis] = useState({})
    const [marketAccessGoals, setMarketAccessGoals] = useState([])
    const [newMarketAccessGoals, setNewMarketAccessGoals] = useState([])
    const [newMarketAccessGoalText, setNewMarketAccessGoalText] = useState('')
    const [marketAccessGoalsMap, setMarketAccessGoalsMap] = useState({})

    const [TPP, setTPP] = useState([])
    const [newTPP, setNewTPP] = useState([])

    const [forceRefresh, setForceRefresh] = useState(false)

    const [vms, setVMs] = useState([])

    const [toDelete, setToDelete] = useState([])

    const [snapshotSaved, setSnapshotSaved] = useState(false)
    const [gapAnalysisVisible, setGapAnalysisVisible] = useState(true)
    const [tppVisible, setTppVisible] = useState(true)

    const gapAnalysisInitializedRef = useRef(false)

    const [TPPFiles, setTPPFiles] = useState([])
    const [newTPPFiles, setNewTPPFiles] = useState([])
    const [TPPFile, setTPPFile] = useState({})
    const [TPPInfo, setTPPInfo] = useState({})
    const [TPPFilesToUpload, setTPPFilesToUpload] = useState([])
    const [existingTPPFiles, setExistingTPPFiles] = useState([])

    const [competitiveLandscapeFiles, setCompetitiveLandscapeFiles] = useState([])
    const [newCompetitiveLandscapeFiles, setNewCompetitiveLandscapeFiles] = useState([])
    const [competitiveLandscapeFile, setCompetitiveLandscapeFile] = useState({})
    const [competitiveLandscapeInfo, setCompetitiveLandscapeInfo] = useState({})
    const [competitiveLandscapeFilesToUpload, setCompetitiveLandscapeFilesToUpload] = useState([])
    const [existingCompetitiveLandscapeFiles, setExistingCompetitiveLandscapeFiles] = useState([])

    const [marketAccessGoalsFiles, setMarketAccessGoalsFiles] = useState([])
    const [newMarketAccessGoalsFiles, setNewMarketAccessGoalsFiles] = useState([])
    const [marketAccessGoalsFile, setMarketAccessGoalsFile] = useState({})
    const [marketAccessGoalsInfo, setMarketAccessGoalsInfo] = useState({})
    const [marketAccessGoalsFilesToUpload, setMarketAccessGoalsFilesToUpload] = useState([])
    const [existingMarketAccessGoalsFiles, setExistingMarketAccessGoalsFiles] = useState([])

    const [criticalSuccessFactorsFiles, setCriticalSuccessFactorsFiles] = useState([])
    const [newCriticalSuccessFactorsFiles, setNewCriticalSuccessFactorsFiles] = useState([])
    const [criticalSuccessFactorsFile, setCriticalSuccessFactorsFile] = useState({})
    const [criticalSuccessFactorsInfo, setCriticalSuccessFactorsInfo] = useState({})
    const [criticalSuccessFactorsFilesToUpload, setCriticalSuccessFactorsFilesToUpload] = useState([])
    const [existingCriticalSuccessFactorsFiles, setExistingCriticalSuccessFactorsFiles] = useState([])

    const [optionalFifthBoxFiles, setOptionalFifthBoxFiles] = useState([])

    const [fifthBoxFilesToUpload, setFifthBoxFilesToUpload] = useState([])

    const [uploading, setUploading] = useState(false)
    const [uploadingFileName, setUploadingFileName] = useState('')
    const [uploadStatus, setUploadStatus] = useState(null)

    const selectedStrategy = useSelector((state) => state.strategy)
    const selectedStrategyId = selectedStrategy?._id

    const valuePropositionDisplayName = useValuePropositionDisplayName()

    const location = useLocation()

    const selectedDashboardTabId = getDashboardTabIdFromPathname(location.pathname)
    const selectedCommentsTabId = getCommentsTabIdFromPathname(location.pathname)
    const selectedMetricsTabId = getMetricsTabIdFromPathname(location.pathname)
    const selectedMetricsScenarioSlug = getMetricsScenarioSlugFromPathname(location.pathname)

    useEffect(() => {
        if (isLoading) return
        if (!selectedStrategyId) {
            console.log('No selected strategy.')
            history.push('/roadmaps')
        }
    }, [history, selectedStrategyId, isLoading])

    useEffect(() => {
        if (!location.pathname.startsWith('/dashboard')) {
            return
        }

        const normalizedPath = getDashboardPath(selectedDashboardTabId, {
            commentsTabId: selectedCommentsTabId,
            metricsTabId: selectedMetricsTabId,
            metricsScenarioSlug: selectedMetricsScenarioSlug,
        })

        if (location.pathname !== normalizedPath) {
            history.replace(normalizedPath)
        }
    }, [
        history,
        location.pathname,
        selectedCommentsTabId,
        selectedDashboardTabId,
        selectedMetricsScenarioSlug,
        selectedMetricsTabId,
    ])

    useEffect(() => {
        if (!selectedStrategyId || !isAuthenticated) return

        if (!gapAnalysisInitializedRef.current) {
            gapAnalysisInitializedRef.current = true
            initGapAnalysisVisible()
        }

        if (gapAnalysisVisible) {
            getVMData()
            getGapAnalysis()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAuthenticated, gapAnalysisVisible, selectedStrategyId])

    async function initGapAnalysisVisible() {
        if (!selectedStrategy) return

        let token = await getTokenSilently({ audience: 'https://atlas.aesara.com' })
        let org = (
            await callSecureAPI(
                endpoints.getOrganizationById.url + selectedStrategy.organizationId,
                endpoints.getOrganizationById.method,
                token
            )
        ).data
        if (org && org.hideMenuItem && org.hideMenuItem['Gap Analyses']) {
            setGapAnalysisVisible(false)
        }
        if (org && org.hideMenuItem && org.hideMenuItem['TPP']) {
            setTppVisible(false)
        }
    }

    async function getVMData() {
        if (!selectedStrategy) return

        let token = await getTokenSilently({ audience: 'https://atlas.aesara.com' })
        let vms = await callAPI(
            endpoints.getValueMessagesForTable.url + selectedStrategy._id,
            endpoints.getValueMessagesForTable.method,
            token
        )
        if (vms.success) {
            setVMs(vms.data)
        }
    }

    async function getGapAnalysis() {
        if (!selectedStrategy) return

        let token = await getTokenSilently({ audience: 'https://atlas.aesara.com' })
        let gap = await callAPI(
            endpoints.getGapAnalysis.url + selectedStrategy._id,
            endpoints.getGapAnalysis.method,
            token
        )
        if (gap.success) {
            setGapAnalysis(gap.data)
            setMarketAccessGoals(gap.data.goals)
            setNewMarketAccessGoals(gap.data.goals)
            setNewMarketAccessGoalText('')
        }
    }

    const { setStrategy: setStrategyProp, setUserRecord: setUserRecordProp } = props

    useEffect(() => {
        // This fires when component mounts, when positioningStatement is refreshed,
        // and when the selected strategy changes.

        if (forceRefresh) {
            setForceRefresh(false)
        }

        if (isLoading) return

        if (!selectedStrategyId) {
            history.push('/roadmaps')
            return
        }

        if (!_.isEmpty(user)) {
            getUser()
        }

        async function getUser() {
            let token = await getTokenSilently({ audience: 'https://atlas.aesara.com' })
            let parsedUserId = user.sub.split('|')
            if (parsedUserId.length >= 2) {
                let userId = parsedUserId.slice(1).join('|')
                let userData = await callAPI(
                    endpoints.getUserAuth0.url + userId + '/auth0',
                    endpoints.getUserAuth0.method,
                    token
                )
                if (userData.data?.organizationId !== selectedStrategy.organizationId) {
                    history.push('/roadmaps')
                } else {
                    setAuthenticated(true)
                    setUserRecordProp(userData.data)
                }
            }
        }

        async function getStrategyData() {
            let token = await getTokenSilently({ audience: 'https://atlas.aesara.com' })
            let strategyResponse = await callAPI(
                endpoints.getStrategy.url + selectedStrategyId,
                endpoints.getStrategy.method,
                token
            )
            if (!strategyResponse.success) {
                return
            }
            const strategy = strategyResponse.data
            setStrat(strategy)
            setStrategyProp(strategy)
            setPositioningStatement(strategy.positioningStatement)
            setNewPositioningStatement(strategy.positioningStatement)
            setCompetitiveLandscape(strategy.competitiveLandscape)
            setNewCompetitiveLandscapes(strategy.competitiveLandscape)
            setCriticalSuccessFactors(strategy.criticalSuccessFactors)
            setNewCriticalSuccessFactors(strategy.criticalSuccessFactors)
            setNewCriticalSuccessFactor('')
            setTPP(strategy.TPP)
            setNewTPP(strategy.TPP)
            setKeyMarkets(strategy.keyMarkets)
            setNewKeyMarket({})
            setNewKeyMarkets(strategy.keyMarkets)
            setFifthButtonValues(strategy.optionalFifthBoxDashboard)
            setNewFifthButtonValues(strategy.optionalFifthBoxDashboard)
            setNewFifthButtonItem('')
            setTPPFiles(strategy.TPPFiles)
            setNewTPPFiles(strategy.TPPFiles)
            setCompetitiveLandscapeFiles(strategy.competitiveLandscapeFiles)
            setNewCompetitiveLandscapeFiles(strategy.competitiveLandscapeFiles)
            setMarketAccessGoalsFiles(strategy.marketAccessGoalsFiles)
            setNewMarketAccessGoalsFiles(strategy.marketAccessGoalsFiles)
            setCriticalSuccessFactorsFiles(strategy.criticalSuccessFactorsFiles)
            setNewCriticalSuccessFactorsFiles(strategy.criticalSuccessFactorsFiles)
            setOptionalFifthBoxFiles(strategy.optionalFifthBoxFiles)
            setLoaded(true)
            buildStrategicImperativesMap(strategy.strategicImperatives)
            buildCriticalSuccessFactorMap(strategy.criticalSuccessFactors)
            buildFifthButtonValuesMap(strategy.optionalFifthBoxDashboard)
        }

        if (!isLoading && isAuthenticated && selectedStrategyId) {
            getStrategyData()
        }
    }, [
        forceRefresh,
        setStrategyProp,
        setUserRecordProp,
        isAuthenticated,
        isLoading,
        getTokenSilently,
        history,
        user,
        selectedStrategyId,
    ])

    async function savePositioningStatement() {
        setEditing(false)
        let token = await getTokenSilently({ audience: 'https://atlas.aesara.com' })

        await callAPI(endpoints.updateStrategy.url + strategy._id, endpoints.updateStrategy.method, token, {
            positioningStatement: newPositioningStatement,
            keyMarkets: newKeyMarkets,
            competitiveLandscape: newCompetitiveLandscapes,
            TPP: newTPP,
            criticalSuccessFactors: Object.values(criticalSuccessFactorsMap),
            optionalFifthBoxDashboard: Object.values(fifthButtonMap),
        })

        // Invalidate Value Narratives cache so localMarkets changes from keyMarkets update are reflected
        await queryClient.invalidateQueries('valueNarratives')

        setForceRefresh(true)
        setPositioningStatement(newPositioningStatement)
        setKeyMarkets(newKeyMarkets)
        setCompetitiveLandscape(newCompetitiveLandscapes)
        setTPP(newTPP)
        setCriticalSuccessFactors(newCriticalSuccessFactors)
        setFifthButtonValues(newFifthButtonValues)
    }

    function handleCancel() {
        setNewPositioningStatement(positioningStatement)
        setNewKeyMarket({})
        setNewKeyMarkets(keyMarkets)
        setEditing(false)
        setUploadStatus(null)
        setUploadingFileName('')
    }

    function onCountryChange(object, value) {
        setNewKeyMarket(value)
    }

    function handleNewMarket(e) {
        e.preventDefault()
        if (_.isEmpty(newKeyMarket)) {
            return
        }
        let newArr = Array.from(newKeyMarkets)
        let newMarketArr = Array.from(newKeyMarkets[editedPhaseTitlePosition].phaseKeyMarkets)
        newMarketArr.push({ code: newKeyMarket.code, label: newKeyMarket.label, targetLaunchDate: '' })
        newArr.splice(editedPhaseTitlePosition, 1, {
            phaseTitle: newKeyMarkets[editedPhaseTitlePosition].phaseTitle,
            phaseKeyMarkets: newMarketArr,
        })
        setNewKeyMarkets(newArr)
        setNewKeyMarket({})
    }

    function countryToFlag(isoCode) {
        return typeof String.fromCodePoint !== 'undefined'
            ? isoCode.replace(/./g, (char) => String.fromCodePoint(char.charCodeAt(0) + 127397))
            : isoCode
    }

    const handleTPPClickOpen = () => {
        setOpenTPP(true)
    }
    const handleTPPClose = async () => {
        setOpenTPP(false)
        setTPPFile({})
        setTPPInfo({})
        setNewTPPFiles(TPPFiles)
        await new Promise((r) => setTimeout(r, 500))
        setNewTPP(TPP)
        setSelectedFiles([])
        setTPPFilesToUpload([])
        setUploadStatus(null)
        setUploadingFileName('')
    }

    const handleTPPSave = async () => {
        savePositioningStatement()
        setTPPFile({})
        setTPPInfo({})
        setOpenTPP(false)
        setSelectedFiles([])
        setTPPFilesToUpload([])
    }
    const handleCompetitiveClickOpen = () => {
        setOpenCompetitiveLandscape(true)
    }

    const handleCompetitiveClose = async () => {
        setOpenCompetitiveLandscape(false)
        setCompetitiveLandscapeFile({})
        setCompetitiveLandscapeInfo({})
        setNewCompetitiveLandscapeFiles(competitiveLandscapeFiles)
        await new Promise((r) => setTimeout(r, 500))
        setNewCompetitiveLandscapes(competitiveLandscape)
        setCompetitiveLandscapeFilesToUpload([])
        setUploadStatus(null)
        setUploadingFileName('')
    }

    const handleCompetitiveLandscapeSave = () => {
        savePositioningStatement()
        setCompetitiveLandscapeFile({})
        setCompetitiveLandscapeInfo({})
        setOpenCompetitiveLandscape(false)
        setCompetitiveLandscapeFilesToUpload([])
    }

    const handleMarketOpen = () => {
        setOpenMarket(true)
    }

    const handleMarketClose = async () => {
        setNewMarketAccessGoalText('')
        setOpenMarket(false)
        setMarketAccessGoalsFile({})
        setMarketAccessGoalsInfo({})
        setNewMarketAccessGoalsFiles(marketAccessGoalsFiles)
        await new Promise((r) => setTimeout(r, 500))
        buildMarketAccessGoalMap(marketAccessGoals)
        setNewMarketAccessGoals(marketAccessGoals)
        setMarketAccessGoalsFilesToUpload([])
        setUploadStatus(null)
        setUploadingFileName('')
    }

    const handleMarketSave = async () => {
        let token = await getTokenSilently({ audience: 'https://atlas.aesara.com' })

        let newGap = {
            overallSummaryRating: gapAnalysis.overallSummaryRating,
            description: gapAnalysis.description,
            goals: newMarketAccessGoals,
            strategyId: gapAnalysis.strategyId,
            organizationId: gapAnalysis.organizationId,
            gapAssessment: gapAnalysis.gapAssessment,
            reimbursableFile: gapAnalysis.reimbursableFile,
        }
        await callAPI(
            endpoints.updateGapAnalysis.url + gapAnalysis._id,
            endpoints.updateGapAnalysis.method,
            token,
            newGap
        )
        savePositioningStatement()
        setMarketAccessGoalsFile({})
        setMarketAccessGoalsInfo({})
        setMarketAccessGoals(newMarketAccessGoals)
        setOpenMarket(false)
        setMarketAccessGoalsFilesToUpload([])
    }

    function buildMarketAccessGoalMap(mags) {
        let newObj = {}
        for (let mag of mags) {
            newObj[mag.title] = mag.title
        }
        setMarketAccessGoalsMap(newObj)
    }

    function buildStrategicImperativesMap(strats) {
        let newObj = {}
        for (let strat of strats) {
            newObj[strat] = strat
        }
        setStrategicImperativeMap(newObj)
    }

    function buildCriticalSuccessFactorMap(factors) {
        let newObj = {}
        for (let factor of factors) {
            newObj[factor] = factor
        }
        setCriticalSuccessFactorsMap(newObj)
    }

    function buildFifthButtonValuesMap(values) {
        let newObj = {}
        for (let value of values) {
            newObj[value] = value
        }
        setFifthButtonMap(newObj)
    }

    function updateFifthButtonValuesMap(event, row) {
        let newObj = { ...fifthButtonMap }
        newObj[row] = event
        setFifthButtonMap(newObj)
    }

    const handleFifthButtonsSave = () => {
        savePositioningStatement()
        setOpen5thButton(false)
    }

    const handleFifthButtonClickOpen = () => {
        setOpen5thButton(true)
    }

    const handleFifthButtonClickClose = async () => {
        setOpen5thButton(false)
        // Added this 'sleep' so that there is no jerky update as the modal closes
        await new Promise((r) => setTimeout(r, 500))
        buildFifthButtonValuesMap(fifthButtonValues)
        setNewFifthButtonValues(fifthButtonValues)
        setFifthBoxFilesToUpload([])
        setUploadStatus(null)
        setUploadingFileName('')
    }

    function updateCriticalSuccessFactorsMap(event, row) {
        let newObj = { ...criticalSuccessFactorsMap }
        newObj[row] = event
        setCriticalSuccessFactorsMap(newObj)
    }

    const handleCriticalSuccessSave = () => {
        savePositioningStatement()
        setCriticalSuccessFactorsFile({})
        setCriticalSuccessFactorsInfo({})
        setOpenCriticalSuccess(false)
        setCriticalSuccessFactorsFilesToUpload([])
    }

    const handleCriticalSuccessClickOpen = () => {
        setOpenCriticalSuccess(true)
    }

    const handleCriticalSuccessClose = async () => {
        setOpenCriticalSuccess(false)
        setCriticalSuccessFactorsFile({})
        setCriticalSuccessFactorsInfo({})
        setNewCriticalSuccessFactorsFiles(criticalSuccessFactorsFiles)
        // Added this 'sleep' so that there is no jerky update as the modal closes
        await new Promise((r) => setTimeout(r, 500))
        buildCriticalSuccessFactorMap(criticalSuccessFactors)
        setNewCriticalSuccessFactors(criticalSuccessFactors)
        setCriticalSuccessFactorsFilesToUpload([])
        setUploadStatus(null)
        setUploadingFileName('')
    }

    async function removeFile(s3Name, fileType) {
        // :id/removeFile/:s3Name/:fileType
        let token = await getTokenSilently({ audience: 'https://atlas.aesara.com' })
        await callAPI(
            endpoints.removeStrategyFile.url + strategy._id + '/removeFile/' + s3Name + '/' + fileType,
            endpoints.removeStrategyFile.method,
            token
        )
        setForceRefresh(true)
        setOpenDeleteModal(false)
    }

    let anchors = [
        {
            title: _.isEmpty(store.getState().settings) ? '' : store.getState().settings.displayNames.tpp,
            action: handleTPPClickOpen,
            condition: () => tppVisible,
        },
        {
            title: store.getState().settings?.displayNames?.competitiveLandscape || 'Loading',
            action: handleCompetitiveClickOpen,
        },
        {
            title: store.getState().settings?.displayNames?.criticalSuccessFactors || 'Loading',
            action: handleCriticalSuccessClickOpen,
        },
        {
            title:
                (store.getState().settings?.displayNames?.marketAccessGoals &&
                    store.getState().settings?.displayNames?.marketAccessGoals) ||
                'Loading',
            action: handleMarketOpen,
            condition: () => gapAnalysisVisible,
        },
        {
            title:
                (store.getState().settings?.displayNames?.fifthBoxDashboard &&
                    store.getState().settings?.displayNames?.fifthBoxDashboard) ||
                'Loading',
            action: handleFifthButtonClickOpen,
            condition: () => store.getState().settings?.showFifthBoxDashboard,
        },
    ]

    let filteredAnchors = anchors.filter((anchor) => !anchor.condition || anchor.condition())

    const Item = styled(Paper)(({ theme }) => ({
        backgroundColor: 'rgba(56, 155, 255, .05)',
        border: '1px solid rgba(56, 155, 255, .5)',
        ...theme.typography.body2,
        padding: theme.spacing(1),
        // color: theme.palette.text.primary,
    }))

    const handleEditOpen = () => {
        setOpenEdit(true)
    }
    const handleEditCancel = () => {
        setOpenEdit(false)
        setIsEditingPhaseTitle(false)
        setEditedPhaseTitlePosition(null)
        setNewKeyMarkets(keyMarkets)
        setUploadStatus(null)
        setUploadingFileName('')
    }

    const handleEditSave = () => {
        setOpenEdit(false)
        setIsEditingPhaseTitle(false)
        setEditedPhaseTitlePosition(null)
        savePositioningStatement()
    }

    const BootstrapDialog = styled(Dialog)(({ theme }) => ({
        '& .MuiDialogContent-root': {
            padding: theme.spacing(2),
        },
        '& .MuiDialogActions-root': {
            padding: theme.spacing(1),
        },
    }))

    const [hover, mouseEvents] = useHover()

    async function updateStrategyFiles(newFiles, fileType) {
        let token = await getTokenSilently({ audience: 'https://atlas.aesara.com' })
        await callAPI(
            endpoints.updateStrategy.url + store.getState().strategy._id,
            endpoints.updateStrategy.method,
            token,
            { [fileType]: newFiles }
        )
        setForceRefresh(true)
    }

    const handleFileChange = async (event, fileType) => {
        if (!event) return
        const file = event.target?.files[0]
        if (!file) return

        setUploading(true)
        setUploadStatus(null)
        setUploadingFileName(file.name)

        const formData = new FormData()
        formData.append('userfile', file)

        try {
            let timestamp = Date.now().toString()
            let token = await getTokenSilently({ audience: 'https://atlas.aesara.com' })
            let fileUpload = await uploadFile(file, timestamp, fileType, token)

            if (fileUpload.success) {
                setUploadStatus({ severity: 'success', message: 'Upload completed successfully!' })
            }

            let filesToUpload = []

            let payload = {
                s3Name: timestamp,
                mimeType: file.type,
                originalFileName: file.name,
                atlasFileType: fileType,
                link: file,
            }

            switch (fileType) {
                case 'competitiveLandscape':
                    filesToUpload = [...competitiveLandscapeFiles, payload]
                    updateStrategyFiles(filesToUpload, 'competitiveLandscapeFiles')
                    break
                case 'TPP':
                    filesToUpload = [...TPPFiles, payload]
                    updateStrategyFiles(filesToUpload, 'TPPFiles')

                    break
                case 'marketAccessGoals':
                    filesToUpload = [...marketAccessGoalsFiles, payload]
                    updateStrategyFiles(filesToUpload, 'marketAccessGoalsFiles')

                    break
                case 'optionalFifthBox':
                    filesToUpload = [...optionalFifthBoxFiles, payload]
                    updateStrategyFiles(filesToUpload, 'optionalFifthBoxFiles')
                    break
                case 'criticalSuccessFactors':
                    filesToUpload = [...criticalSuccessFactorsFiles, payload]
                    updateStrategyFiles(filesToUpload, 'criticalSuccessFactorsFiles')
                    break
                default:
                    break
            }
        } catch (error) {
            console.error('Upload failed:', error)
            setUploadStatus({ severity: 'error', message: 'Upload failed. Please try again.' })
        } finally {
            setUploading(false)
        }
    }

    const { getStrategicAnchorFile } = useGetStrategicAnchorFile()

    const handleDownloadStrategicAnchorFile = async (anchorType, index) => {
        let fileName = ''
        let fileType = ''

        switch (anchorType) {
            case 'TPP':
                fileName = TPPFiles[index].originalFileName
                fileType = TPPFiles[index].mimeType
                break
            case 'competitiveLandscape':
                fileName = competitiveLandscapeFiles[index].originalFileName
                fileType = competitiveLandscapeFiles[index].mimeType
                break
            case 'criticalSuccessFactors':
                fileName = criticalSuccessFactorsFiles[index].originalFileName
                fileType = criticalSuccessFactorsFiles[index].mimeType
                break
            case 'marketAccessGoals':
                fileName = marketAccessGoalsFiles[index].originalFileName
                fileType = marketAccessGoalsFiles[index].mimeType
                break
            case 'optionalFifthBox':
                fileName = optionalFifthBoxFiles[index].originalFileName
                fileType = optionalFifthBoxFiles[index].mimeType
                break
            default:
                break
        }

        const strategicAnchorFile = await getStrategicAnchorFile(store.getState().strategy._id, anchorType, index)

        if (strategicAnchorFile) {
            await download(strategicAnchorFile, fileName, fileType)
        }
    }

    const overviewTabProps = {
        isDarkMode,
        isEditingPhaseTitle,
        setIsEditingPhaseTitle,
        editedPhaseTitlePosition,
        setEditedPhaseTitlePosition,
        hoveredFieldId,
        setHoveredFieldId,
        onCountryChange,
        handleNewMarket,
        classes,
        newKeyMarketPhase,
        setNewKeyMarketPhase,
        newPositioningStatement,
        setNewPositioningStatement,
        valuePropositionDisplayName,
        positioningStatement,
        filteredAnchors,
        Item,
        newKeyMarkets,
        setNewKeyMarkets,
        openEdit,
        handleEditCancel,
        handleEditSave,

        handleTPPClose,
        openTPP,
        newTPP,
        snapshotMode,
        userReadonly,
        setNewTPP,
        handleFileChange,
        uploading,
        uploadingFileName,
        uploadStatus,
        TPPFiles,
        handleDownloadStrategicAnchorFile,
        setOpenDeleteModal,
        setToDelete,
        handleTPPSave,

        handleCompetitiveClose,
        openCompetitiveLandscape,
        newCompetitiveLandscapes,
        setNewCompetitiveLandscapes,
        handleCompetitiveLandscapeSave,
        competitiveLandscapeFiles,

        handleCriticalSuccessClose,
        openCriticalSuccess,
        newCriticalSuccessFactors,
        setNewCriticalSuccessFactors,
        newCriticalSuccessFactor,
        setNewCriticalSuccessFactor,
        buildCriticalSuccessFactorMap,
        criticalSuccessFactorsMap,
        updateCriticalSuccessFactorsMap,
        criticalSuccessFactorsFiles,
        handleCriticalSuccessSave,
        setCriticalSuccessFactorsMap,

        handleFifthButtonClickClose,
        open5thButton,
        newFifthButtonItem,
        setNewFifthButtonItem,
        newFifthButtonValues,
        setNewFifthButtonValues,
        buildFifthButtonValuesMap,
        fifthButtonMap,
        updateFifthButtonValuesMap,
        setFifthButtonMap,
        optionalFifthBoxFiles,
        handleFifthButtonsSave,

        openMarket,
        handleMarketClose,
        newMarketAccessGoalText,
        setNewMarketAccessGoalText,
        newMarketAccessGoals,
        setNewMarketAccessGoals,
        buildMarketAccessGoalMap,
        marketAccessGoalsMap,
        setMarketAccessGoalsMap,
        marketAccessGoalsFiles,
        handleMarketSave,

        openDeleteModal,
        toDelete,
        removeFile,
    }

    const handleDashboardTabChange = useCallback(
        (id) => {
            history.push(
                getDashboardPath(id, {
                    commentsTabId: selectedCommentsTabId,
                    metricsTabId: selectedMetricsTabId,
                    metricsScenarioSlug: selectedMetricsScenarioSlug,
                })
            )
        },
        [history, selectedCommentsTabId, selectedMetricsTabId, selectedMetricsScenarioSlug]
    )

    const handleMetricsTabChange = useCallback(
        (metricsTabId) => history.push(getDashboardPath('metrics', { metricsTabId, metricsScenarioSlug: null })),
        [history]
    )

    const handleMetricsScenarioChange = useCallback(
        (metricsScenarioSlug) =>
            history.replace(getDashboardPath('metrics', { metricsTabId: 'tpp', metricsScenarioSlug })),
        [history]
    )

    const handleCommentsTabChange = useCallback(
        (commentsTabId) => history.push(getDashboardPath('comments', { commentsTabId })),
        [history]
    )

    const metricsTabView = useMemo(
        () => (
            <MetricsView
                selectedTabId={selectedMetricsTabId}
                selectedScenarioSlug={selectedMetricsScenarioSlug}
                onTabChange={handleMetricsTabChange}
                onScenarioChange={handleMetricsScenarioChange}
            />
        ),
        [selectedMetricsTabId, selectedMetricsScenarioSlug, handleMetricsTabChange, handleMetricsScenarioChange]
    )

    const commentsTabView = useMemo(
        () => <CommentsView selectedTabId={selectedCommentsTabId} onTabChange={handleCommentsTabChange} />,
        [selectedCommentsTabId, handleCommentsTabChange]
    )

    const dashboardTabs = useMemo(
        () => [
            { id: 'overview', label: 'Overview', view: <DashboardOverviewTab {...overviewTabProps} /> },
            { id: 'metrics', label: 'Metrics', view: metricsTabView },
            { id: 'comments', label: 'Comments', view: commentsTabView },
        ],
        [metricsTabView, commentsTabView, overviewTabProps]
    )

    return (
        <Fade in={loaded && authenticated} timeout={800}>
            <Grid container item p={2}>
                <DashboardHeader
                    strategy={strategy}
                    editing={editing}
                    snapshotMode={snapshotMode}
                    userReadonly={userReadonly}
                    handleCancel={handleCancel}
                    savePositioningStatement={savePositioningStatement}
                    handleEditOpen={handleEditOpen}
                    hideEditButton={selectedDashboardTabId === 'metrics'}
                />
                <Tabs
                    orientation="horizontal"
                    selectedTabId={selectedDashboardTabId}
                    onTabChange={handleDashboardTabChange}
                    tabs={dashboardTabs}
                    sx={{ width: '100%' }}
                    tabListSx={{ mb: 2 }}
                    tabPanelSx={{ width: '100%' }}
                />
            </Grid>
        </Fade>
    )
}

const Dashboard = connect(null, mapDispatchToProps)(ConnectedDashboard)

export default Dashboard
